import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'simple-header',
  footer: 'dc-footer-clean',
}

const pageBrand: PageBrand = 'consumer'

export const inAppHeaderFooter = new LineOfBusinessConfig(geConfig, pageBrand)
